/* Panier Shopify : tiroir #pcart, ajout par /cart/add.js, contenu par /cart.js */
(function(){
  var cart = document.getElementById('pcart'); if(!cart) return;
  var list = cart.querySelector('[data-cart-items]'), empty = cart.querySelector('[data-cart-empty]');
  var foot = cart.querySelector('[data-cart-foot]'), total = cart.querySelector('[data-cart-total]'), last = null;
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); };
  var fmt = function(c){ return '£' + (c / 100).toFixed(2); };
  var thumb = function(u){ return u ? u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=160' : ''; };
  function render(c){
    empty.hidden = c.item_count > 0; foot.hidden = !c.item_count;
    list.innerHTML = c.items.map(function(i){
      return '<div class="pcart__item"><img src="' + esc(thumb(i.image)) + '" alt=""><div><p class="pcart__name">' + esc(i.product_title) + '</p>' +
        (i.variant_title ? '<p class="pcart__meta">' + esc(i.variant_title) + '</p>' : '') +
        '<p class="pcart__meta">' + i.quantity + ' × ' + fmt(i.final_price) + '</p>' +
        '<button type="button" class="pcart__rm" data-key="' + esc(i.key) + '">Remove</button></div></div>';
    }).join('');
    total.textContent = fmt(c.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(function(n){ n.textContent = c.item_count; n.hidden = !c.item_count; });
    return c;
  }
  function refresh(){ return fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(function(r){ return r.json(); }).then(render); }
  function open(btn){ last = btn || null; cart.classList.add('is-open'); cart.setAttribute('aria-hidden', 'false'); cart.querySelector('.pcart__close').focus(); }
  function close(){ cart.classList.remove('is-open'); cart.setAttribute('aria-hidden', 'true'); if(last) last.focus(); }
  document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(){ refresh(); open(b); }); });
  cart.querySelector('.pcart__back').addEventListener('click', close);
  cart.querySelector('.pcart__close').addEventListener('click', close);
  addEventListener('keydown', function(e){ if(e.key === 'Escape' && cart.classList.contains('is-open')) close(); });
  list.addEventListener('click', function(e){
    var b = e.target.closest('[data-key]'); if(!b) return;
    fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: b.dataset.key, quantity: 0})})
      .then(function(r){ return r.json(); }).then(render);
  });
  window.HollinCart = {
    open: open, refresh: refresh,
    add: function(id, btn){
      return fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [{id: id, quantity: 1}]})})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description || j.message || 'Could not add to basket'); return j; }); })
        .then(refresh).then(function(){ open(btn); });
    }
  };
})();
